<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('passports.title')"></page-header-title>
      <v-spacer></v-spacer>
      <v-chip color="primary">
        <b>{{ $t("organisations.swagger_token") }} : &nbsp;</b>
        <span v-if="swaggerToken">
          {{ swaggerToken }}

          <input class="d-none" type="text" :value="swaggerToken" id="copy-swagger-token" />
          
          <v-tooltip v-model="showInfoLinkCopiedToolTip" bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="white" x-small :title="$t('global.copy')" @click="swaggerCopy">
                <v-icon>fas fa-copy</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("global.copied") }}</span>
          </v-tooltip>

          <v-btn icon color="white" x-small :title="$t('organisations.open_swagger')" @click="swaggerOpen">
            <v-icon>open_in_new</v-icon>
          </v-btn>
        </span>
        <span v-else>N/A</span>
      </v-chip>
      <action-button type="new" @click="showForm(null, 'passport')" :text="$t('passports.create_new_key')" />
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="passports"
            :items-per-page="passports.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.actions="{ item }">
              <action-button type="view" @click="showForm(item.id, 'passport')" v-if="$can('passport-access')" small />

              <!--<router-link
                :to="{ path: BACKEND_URL + '/passports/test/' + item.id, props: { id: item.id } }"
                :disabled="Boolean(item.revoked)"
                :event="!Boolean(item.revoked) ? 'click' : ''"
                v-if="$can('passport-access')"
              >
                <action-button type="validate" :text="$t('passports.test')" :disabled="Boolean(item.revoked)" small />
              </router-link>-->

              <action-button
                type="cancel"
                :text="$t('passports.revoked')"
                @click="revoke(item.id)"
                :disabled="Boolean(item.revoked)"
                v-if="$can('passport-delete')"
                small
              />
              <!--<action-button type="delete" v-if="$can('passport-delete')" small/>-->
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDialogForm" persistent max-width="80%">
      <div class="form-modal pa-4 pt-0">
        <component
          :key="formKey"
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "PassportList",

  components: {
    "passport-form": () => import("../../passports/components/Form")
  },

  data() {
    return {
      url: "",
      passports: [],
      total: 0,
      show_loading: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__passportListPage", "page"),
        itemsPerPage: JSON.parse(localStorage.getItem("__crrntUser")).settings.find((i) => i.key == "rows_per_page").value,
        sortBy: ["created_at"],
        sortDesc: [true]
      },
      search_params: {},
      from_date_menu: false,
      to_date_menu: false,
      formKey: 0,
      currentFormId: "",
      currentForm: "",
      showDialogForm: false,
      swaggerToken: null,
      showInfoLinkCopiedToolTip: false
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("passports.client_id"), value: "id", width: "10%" },
          { text: this.$t("passports.name"), value: "name" },
          { text: this.$t("global.actions"), value: "actions", align: "end" }
        ]
      }
    },
    currentLoadedForm: {
      get() {
        let form,
          id = null

        if (this.currentForm) {
          this.showDialogForm = true

          id = this.currentFormId
          form = this.currentForm
        }

        return {
          id: id,
          form: form
        }
      },
      set() {}
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__passportListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__passportListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "passport/clients"
  },

  created() {
    this.getOrganisation()
  },

  methods: {
    list(url) {
      this.show_loading = true

      let params = JSON.parse(JSON.stringify(this.search_params))
      params.from_date = params.from_date ? "gte-" + params.from_date : ""
      params.to_date = params.to_date ? "lte-" + params.to_date : ""

      let localSort = localStorage.getItem("__passportListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, params)

      axios
        .get(this.url + "?" + query)
        .then((res) => {
          this.passports = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    getOrganisation() {
      axios
        .get(this.API_URL + "organisation/my?resourcetype=basic")
        .then((res) => {
          let data = res.data.data
          this.swaggerToken = data.swagger_token || null
        })
        .catch((err) => console.log(err))
    },

    revoke(id) {
      this.$awn.confirm(
        this.$t("passports.revoked_confirm"),
        () => {
          axios
            .post(this.API_URL + "passport/client/revoke/" + id)
            .then((res) => {
              if (res.data.data.id) {
                let data = res.data.data

                let idx = this.passports.findIndex((i) => i.id == id)
                this.$set(this.passports[idx], "revoked", data.revoked)

                this.$awn.success(this.$t("passports.revoked_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    },

    showForm(id, type) {
      this.formKey++
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.refresh = true
    },
    return_modal_cancel_form() {
      this.currentForm = ""
      this.showDialogForm = false
      this.refresh = true
    },
    swaggerCopy() {
      var copyText = document.getElementById("copy-swagger-token")
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)

      this.showInfoLinkCopiedToolTip = true
      setTimeout(() => {
        this.showInfoLinkCopiedToolTip = false
      }, 1000)
    },
    swaggerOpen() {
      if (this.swaggerToken) {
        window.open(this.API_DOMAIN + "/login", "_blank")
      }
    }
  }
}
</script>

<style scoped></style>
